import React from 'react';

import WinXP from 'WinXP';
import Bezel from 'WinXP/Bezel';

const App = () => {
  return (
    <Bezel>
      <WinXP />
    </Bezel>
  );
};

export default App;
